import { FC, useEffect, useState, useCallback } from 'react'
import s from './TopBackBar.module.css'
import Image from "next/legacy/image"
import Link from 'next/link'
import {ArrowLeft} from '@components/icons'

export interface TopBackBarProps {
  text: string
  link: any
}

const TopBackBar: React.FC<TopBackBarProps> = ((props) => {

  const {
    text,
    link
  } = props

  return (
    <div className={s.root}>
      {link !== '' ? (
        <Link href={link} className="bg-tertiary200 text-tertiary500 flex items-center px-space10 py-3">
                <ArrowLeft />
                <span className="ml-4 text-paragraph03">
                    {text}
                </span>
        </Link>
      ) : (
      <span className="bg-tertiary200 text-tertiary500 flex px-6 py-3 text-paragraph03">{text}</span>
      )}
    </div>
  )
})

export default TopBackBar
